import React from "react";
import { Box, Center, Image } from "@chakra-ui/react";
import { genBlock } from "@/utils/bem";
import Icon from "@/components/Icon";

import { ReactComponent as CrossLineSvg } from "@/assets/icons/cross-line.svg";
import { themeStore } from "@/stores/theme";

import "./image-card.scss";
import { PostWorkImageItem } from "../bussiness/PublishForm/type";

const block = genBlock("editor-image-card");
const ImageCard: React.FC<{
  image: PostWorkImageItem;
  onDelete?: () => void;
  deletable: boolean;
}> = ({ image, onDelete, deletable }) => {
  const { panelBg, borderRadius, fillColor, textColor, filledInputBgColor, themeColor } =
    themeStore.styles;
  return (
    <Box
      className={block()}
      border={`1px solid ${filledInputBgColor}`}
      _hover={{ border: `1px solid ${themeColor}` }}
      _active={{ border: `1px solid ${themeColor}` }}
    >
      {deletable ? (
        <Center
          bg={fillColor}
          color={textColor}
          className={block({ e: "delete" })}
          onClick={() => onDelete?.()}
        >
          <Icon strokeByCurrentColor svg={CrossLineSvg} />
        </Center>
      ) : null}
      <Image
        boxSize="100%"
        src={image.src}
        bg={panelBg}
        fit="contain"
        borderRadius={borderRadius}
        border="none"
      />
    </Box>
  );
};

export default ImageCard;
